import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useUser } from "../../../../context/UserContext";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import { createDealRequest } from "../../../../store/features/actions/opportunities/increaseDealSizeActions/createDealActions";
import { listDealsRequest } from "../../../../store/features/actions/opportunities/increaseDealSizeActions/listDealsActions";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";

import OpportunityFilterContainer from "./opportunityFilterContainer/OpportunityFilterContainer";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";

// import BattleCard from "./CardTabs/BattleCard";
import ContactMapCard from "./CardTabs/ContactMapCard";
import BusinessCaseCard from "./CardTabs/BusinessCaseCard";
import Templates from "./CardTabs/Templates";
import News from "./CardTabs/News";
import ValueSellingPrompter from "./CardTabs/ValueSellingFramework";
import NextSteps from "./CardTabs/NextSteps";
import IncreaseDealSizeCard from "./CardTabs/IncreaseDealSizeCard";

import "./SpotOpportunities.css";
import TagList from "../../genericComponents/tag/TagList";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import TagOverflowHandler from "../../uiUtils/TagOverflowHandler";
import TagOverflowHandlerV2 from "../../uiUtils/TagOverflowHandlerV2";
import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "../../../Navigation/memoryComps/MemoryContainerSC";
import GenericTagComp from "../../genericComponents/tag/GenericTagComp";
import SimpleSearchBar from "../../genericComponents/simpleSearchBar/SimpleSearchBar";
import BattleCardV2 from "./CardTabs/BattleCardV2";

const iconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="top_tab_icon"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#535458"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" y1="22.08" x2="12" y2="12"></line>
  </svg>
);

function IncreaseDealSize() {
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const [currRow, setCurrRow] = useState();
  const [activeTab, setActiveTab] = useState("increase_deal_size");
  const [filters, setFilters] = useState({});
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState({
    id: null,
    name: null,
    desc: null,
    mainSignal:null
  });
  const [listDealAPIrefresh, setListDealAPIrefresh] = useState(false);
  const [showMemSc, setShowMemSc] = useState(false);
  const { opportunitesData, opportunitesLoading } = useSelector(
    (state) => state.opportunitiesReducer
  );
  const { winOpportunitesData, winOpportunitesLoading } = useSelector(
    (state) => state.winOpportunitiesReducer
  );
  const { listDealsData, listDealsLoading } = useSelector(
    (state) => state.listDealsReducer
  );
  const { createDealLoading } = useSelector((state) => state.createDealReducer);

  const filterOptions = useMemo(
    () => [...(opportunitesData || []), ...(winOpportunitesData || [])],
    [opportunitesData, winOpportunitesData]
  );

  const tableColumns = useMemo(
    () => [
      { id: "opportunity_name", label: "Deal Name", width: "5rem" },
      { id: "signal", label: "Signal", width:60 },
      { id: "documents", label: "Documents", width: "10rem" },
      // { id: "saveFav", label: "", width: 10, clickAction: true },
    ],
    []
  );

  const commonProps = {
    opportunityId: selectedOpportunity.deal_id,
    opportunityName: selectedOpportunity.name,
    deal_id: selectedOpportunity.deal_id,
    opportunityDescription: selectedOpportunity.desc,
    mainSignal:selectedOpportunity.mainSignal,
    setShowMoreModal,
  };
  const getTabsForRow = (status) => {
    if (status === "in-progress") {
      return [
        {
          key: "increase_deal_size",
          label: "Increase Deal Size",
          Component: () => <IncreaseDealSizeCard {...commonProps} />,
          icon: iconSVG,
        },
      ];
    }
    return [
      {
        key: "battle_card_ids",
        tabId: "battle_card",
        label: "Battle Card",
        Component: () => <BattleCardV2 {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/blueDocIcon.png" width="16"/>,
      },
      {
        key: "contact_map_ids",
        tabId: "contact_map",
        label: "Contact Map",
        Component: () => <ContactMapCard {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/blueDocIcon.png" width="16"/>,
      },
      {
        key: "business_case_ids",
        tabId: "business_case",
        label: "Business Case",
        Component: () => <BusinessCaseCard {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/blueDocIcon.png" width="16"/>,
      },
      // {
      //   key: "template_ids",
      //   tabId: "templates",
      //   label: "Templates",
      //   Component: () => <Templates {...commonProps} />,
      //   icon: iconSVG,
      //   tagIcon: <img src="/img/redDocIcon.png" width="16"/>,
      // },
      {
        key: "news_ids",
        tabId: "news",
        label: "News",
        Component: () => <News {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/redDocIcon.png" width="16" />,
      },
      {
        key: "prompter_ids",
        tabId: "value_selling_prompter",
        label: "Prompter",
        Component: () => <ValueSellingPrompter {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/redDocIcon.png" width="16" />,
      },
      {
        key: "next_step_ids",
        tabId: "next_step",
        label: "Next Step",
        Component: () => <NextSteps {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/redDocIcon.png" width="16" />,
      },
    ];
  };

  const handleSideCard = useCallback((e, item, tabId, childSc) => {
    console.log("handleSideCard", item, tabId, childSc);
    e.preventDefault();
    e.stopPropagation();
    setShowMoreModal(true);
    setSelectedOpportunity({
      id: item?.opportunity_ids,
      name: item?.opportunity_name,
      deal_id: item?.record_id || item?._id,
      desc: "",
      mainSignal:item?.signal
    });

    if (childSc) {
      item.status = "updated";
    }
    setCurrRow(item);
    setActiveTab(tabId || "battle_card_ids");
  }, []);

  const onApply = useCallback(
    (ids) => {
      dispatch(
        createDealRequest({
          opportunityIds: ids,
          userId: user?.id,
          clientName,
          accountName,
        })
      );
      setListDealAPIrefresh(true);
    },
    [dispatch, user?.id]
  );

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      dispatch(
        fetchWinOpportunitiesRequest({
          clientName,
          accountName,
          userId: user.id,
          type: "win",
        })
      );
      dispatch(
        fetchOpportunitiesRequest({
          clientName,
          accountName,
          userId: user.id,
          type: "spot",
        })
      );
      dispatch(listDealsRequest({ userId: user.id }));
    }
  }, [clientName, accountName, user?.id, dispatch]);

  useEffect(() => {
    const hasInProgress = listDealsData?.some(
      (data) => data?.status === "in-progress"
    );
    setListDealAPIrefresh(hasInProgress);
  }, [listDealsData]);

  const tabData = useMemo(() => {
    if (!listDealsData) return [];

    let filteredData = listDealsData;

    if (searchQuery) {
      const query = searchQuery?.toLowerCase();
      filteredData = filteredData.filter(item =>
        item.opportunity_name?.toLowerCase().includes(query) ||
        item.signal?.toLowerCase().includes(query)
      );
    }
    return filteredData.map((item) => {
      const isLoading = item?.status === "in-progress";
      if (isLoading) {
        item.isPartialLoad = (
          <>
            <td colSpan={1} className="gtr-cell-content">
              {item?.opportunity_name}
            </td>

            <td
              colSpan={5}
              className="gtr-expanded-cell"
              onClick={(e) => handleSideCard(e, item, "increase_deal_size")}
            >
              <StatusIndicator />
            </td>
          </>
        );
      } else {
        console.log("isExpandedContent item", item?.combined_opportunities);
        item.isExpandedContent = (
          <tr className="gtr-expanded-content-row">
            <td colSpan={tableColumns.length} style={{backgroundColor:"#A8AAB21A" }}>
              <GenericTable
                disableHeader={true}
                tabData={
                  item.combined_opportunities?.map((childItem, idx) => ({
                    opportunity_name: (
                      <>
                        <div>{childItem?.opportunity_name}</div>
                        <div style={{ color: "#9898A1", fontWeight: "500" }}>
                          Opportunity {idx + 1}
                        </div>
                      </>
                    ),
                    signal: (
                      <GenericTagComp
                        color="gray"
                        text={childItem?.signal}
                        onChipClick={() => null}
                      />
                    ),
                    documents: (
                      <TagOverflowHandler
                        handleSideCard={handleSideCard}
                        tabConfig={getTabsForRow("updated")}
                        rowData={childItem}
                        childSc={true}
                      />
                    ),
                  })) || []
                }
                initialColumns={[
                  {
                    id: "opportunity_name",
                    label: "Child Opportunity",
                    width: 85,
                  },
                  {
                    id: "signal",
                    label: "Signal",
                    width: 60,
                  },
                  {
                    id: "documents",
                    label: "Documents",
                    width: 170,
                  },
                ]}
              />
            </td>
          </tr>
        );

      }

      return {
        ...item,
        opportunity_name: {
          content: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0px",
              }}
            >
              {<div className="gtr-cell-content">{item.opportunity_name}</div>}
            </div>
          ),
          onClickAction: (data) => console.log("data", data),
          expandable: true,
        },
        status: <TagList tags={item?.status} />,
        documents: (
          <TagOverflowHandler
            handleSideCard={handleSideCard}
            tabConfig={getTabsForRow(item?.status)}
            rowData={item}
          />
        ),
        signal: <TagOverflowHandlerV2 data={item?.signal} />,
        // saveFav:<TR3DotMenu  menuItems={[
        //     { label: "Open Side Card", onMenuClick: (e) =>handleSideCard(
        //         e,
        //         item,
        //         isLoading ? "increase_deal_size" : "battle_card_ids",
        //         !isLoading
        //       )  },
        //   ]}/>,

        sideCardTabConfig: getTabsForRow(item?.status),
      };
    });
  }, [listDealsData,searchQuery, handleSideCard]);

  const appliedFiltersCount = useMemo(
    () =>
      Object.values(filters).reduce((sum, val) => sum + (val?.length || 0), 0),
    [filters]
  );

  return (
    <>
      <OpportunityFilterContainer
        filterTxt="Select Opportunities"
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        notSingleton={false}
        onApply={onApply}
        loading={opportunitesLoading || createDealLoading}
        mainTitl="Spot upsell and cross-sell opportunities in existing pipeline"
        filterTitl="Pick one or more from ‘Spot’ or ‘Win Opportunities’"
        oppBtnTitl="Or Increase deal size of existing deal"
        disableFilter={true}
        chatbotBtnTxt="Create Deal"
        parentTab="ids"
      />

      <div className="find-opportunities-container mounted">
        <span className="find-opportunities-header-container">
          <div className="filter-header">
            <h6 className="find-opportunities-results-title">
              Showing{" "}
              {winOpportunitesLoading ||
              opportunitesLoading ||
              listDealsLoading ? (
                <IOSSpinner />
              ) : (
                tabData.length || 0
              )}{" "}
              Results
            </h6>
            {appliedFiltersCount > 0 && (
              <div className="find-opportunities-results-title-filter-badge">
                {appliedFiltersCount} filters applied
                <img
                  src="/img/x.png"
                  alt="Clear filters"
                  onClick={() => setFilters({})}
                />
              </div>
            )}
          </div>
          {/* <button
            className="memory_btn_trans"
            onClick={(e) => {
              setShowMemSc((prev) => !prev);
              dispatch(
                listGlobalMemRequest({
                  userId: user?.id,
                  memoryType: "opportunity",
                })
              );
            }}
          >
            <img src="/img/rotate-ccw.png" className="memory_icon" />
            Memory
          </button> */}
           <SimpleSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={
              currRow?.status ? getTabsForRow(currRow.status) : []
            }
            loading={listDealsLoading}
            showMoreModal={showMoreModal}
            setShowMoreModal={setShowMoreModal}
            titleForSideCard={
              <ScHeaderComp
                key={`side_card_head_comp_${commonProps?.deal_id}`}
                data={currRow}
                type="increase_dealsize"
                setShowMoreModal={setShowMoreModal}
                opportunityId={commonProps?.deal_id}
                tabConfig={getTabsForRow(currRow?.status)}
                showMoreModal={showMoreModal}
                showMemComp={true}
                memoryType={"single-opportunity"}
              />
            }
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>

      <GenericOverviewSideCard
        showMoreModal={showMemSc}
        setShowMoreModal={setShowMemSc}
        titleForSideCard={
          <div className="mem-sc-titl-cont">
            <img
              className="back-btn-img"
              src="/img/backArrow.png"
              onClick={() => setShowMoreModal(false)}
            />{" "}
            <span className="span_memory">Memory</span>
          </div>
        }
        comp={<MemoryContainerSC memoryType="opportunity" />}
        minWidthForDrawer="30%"
        disableXbtn
      />
    </>
  );
}

export default React.memo(IncreaseDealSize);
